import photo_1 from "./VaticanPictures/Photo-01.webp";
import photo_2 from "./VaticanPictures/Photo-02.webp";
import photo_3 from "./VaticanPictures/Photo-03.webp";
import photo_4 from "./VaticanPictures/Photo-04.webp";
import photo_5 from "./VaticanPictures/Photo-05.webp";

export const VaticanPhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: photo_1,
      date: "14 Apr 2025",
      time: "12:49pm",
      location: "",
    },
    pictures: [
      {
        image: photo_1,
        date: "14 Apr 2025",
        time: "12:49pm",
        location: "",
      },
      {
        image: photo_2,
        date: "15 Apr 2025",
        time: "12:47pm",
        location: "",
      },
      {
        image: photo_3,
        date: "16 Apr 2025",
        time: "12:49pm",
        location: "",
      },
      {
        image: photo_4,
        date: "17 Apr 2025",
        time: "12:48pm",
        location: "",
      },
      {
        image: photo_5,
        date: "18 Apr 2025",
        time: "12:47pm",
        location: "",
      },
    ],
  },
];
